// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"265":"canvg","297":"xlsx","643":"pdfmake"}[chunkId] + "." + {"265":"dc9500ab","297":"7bf932e2","643":"30c3d49d"}[chunkId] + ".js";
};